import Home from './Home.af-data.vue'

export default {
  Home
}